import { render } from "./ApplicationList.vue?vue&type=template&id=b3513de6&scoped=true"
import script from "./ApplicationList.vue?vue&type=script&lang=js"
export * from "./ApplicationList.vue?vue&type=script&lang=js"

import "./ApplicationList.vue?vue&type=style&index=0&id=b3513de6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3513de6"]])

export default __exports__